/**
 * Country-aware Legal References (Feb 2026).
 * Spiegelt /app/backend/app/utils/legal_refs.py — bei Änderungen beide Seiten synchron halten.
 */

const REFS = {
  DE: {
    vorsteuer: "§ 15 UStG",
    vorsteuer_berichtigung: "§ 15a UStG",
    reverse_charge_inland: "§ 13b UStG",
    umsatzsteuer_grundlage: "§ 1 UStG",
    afa_nutzungsdauer: "§ 7 EStG",
    korrekturrechnung: "§ 14 Abs. 6 UStG",
    kleinunternehmer: "§ 19 UStG",
  },
  AT: {
    vorsteuer: "§ 12 UStG",
    vorsteuer_berichtigung: "§ 12 Abs. 10–13 UStG",
    reverse_charge_inland: "§ 19 UStG",
    umsatzsteuer_grundlage: "§ 1 UStG",
    afa_nutzungsdauer: "§ 7 EStG",
    korrekturrechnung: "§ 11 Abs. 12 UStG",
    kleinunternehmer: "§ 6 Abs. 1 Z 27 UStG",
  },
  CH: {
    vorsteuer: "Art. 28 MWSTG",
    vorsteuer_berichtigung: "Art. 32 MWSTG",
    reverse_charge_inland: "Art. 45 MWSTG",
    umsatzsteuer_grundlage: "Art. 18 MWSTG",
    afa_nutzungsdauer: "Art. 28 DBG",
    korrekturrechnung: "Art. 27 MWSTG",
    kleinunternehmer: "Art. 10 Abs. 2 MWSTG",
  },
};

export function getLegalRef(country, key) {
  const c = (country || "DE").toUpperCase();
  return (REFS[c] || REFS.DE)[key] || "";
}

export default getLegalRef;
